import Radio from 'backbone.radio';
import RootLayout from '../../../../core/layouts/Root';
import { ActivateGameView, OnboardingView } from '../../views';

const channelUserModals = Radio.channel('userModals');

export default class extends RootLayout {
	initialize() {
		this.listenTo(channelUserModals, 'show:activation:modal', this.showActivationModal);
		this.listenTo(channelUserModals, 'show:onboarding:modal', this.showOnboardingModal);
		this.listenTo(channelUserModals, 'hide:onboarding:modal', this.hideOnboardingModal);

	}

	showActivationModal() {
		this.getRegion('user_modal').show(new ActivateGameView());

		return this;
	}

	showOnboardingModal() {
		this.getRegion('user_modal').show(new OnboardingView({
			game_title: 'Tipping'
		}))
	}

	hideOnboardingModal() {
		this.getRegion('user_modal').currentView.destroy();
	}
}